<template>
  <template v-if="authStore.isAuthenticated">
    <v-app-bar color="#002543" prominent>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="mr-2"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="text-center">
        {{ title }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <nav-drawer v-model="drawer" />
  </template>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import authStore from "@/store/auth";
import NavDrawer from "@/components/NavDrawer.vue";

const drawer = ref(false);
const route = useRoute();

const title = computed(() => {
  return route.meta.title || "DataLake Search";
});
</script>
